<div id="page-title">
  <div id="page-content" class="inicio" id="transacoes">
    <div class="row">
      <div class="col-sm-10 col-sm-offset-1">
        <div class="row">
          <div class="container-datepicker col-xs-12">
            <app-datepicker [initialDate]="initialDate" [finalDate]="finalDate" (filter)="setFilterData($event)"></app-datepicker>
          </div>
        </div>

        <div class="row" [hidden]="!loaded && !error">
          <div class="col-sm-6">
            <div id="input-tag" class="input textarea caixa-pesquisa">
              <div>
                <input [(ngModel)]="inputSearch" (keyup)="filter()" class="input-searchbox" type="text" placeholder="Pesquisar">
              </div>
              <div class="filter-icon" (click)="toggleBox()"></div>
              <div [ngClass]="boxHidden ? 'box-hidden' : 'box-show'" class="box-filter">
                <div class="container-box-inner">
                  <label>Status</label>
                  <div *ngFor="let s of status">
                    <input (change)="changeTag($event, s.name)" id={{s.name}} type="checkbox" class="styled-checkbox" class="hidden">
                    <label for={{s.name}}>{{ s.name }}</label>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div *ngIf="!loaded && !error" class="container-loading">
          <div class="btn btn-registrar loading"></div>
        </div>

        <div class="col-md-10 col-md-offset-1" *ngIf="error">
          <span class="error">Nenhuma informação disponível para o período informado</span>
        </div>
        <table [hidden]="!loaded && !error" id="master-detail-table-vendas" style="width: 100%"></table>
      </div>
    </div>
  </div>
</div>

<app-modal-detail [showModal]="showModal" (eventClose)="eventClose()">
  <div class="modal-header" [ngClass]="getSaleStatus().className">
    <h2>{{ getSaleStatus().title }}</h2>
  </div>
  <div class="modal-body">
    <div class="row">
      <div class="col-xs-12 col-sm-6">
        <div class="form-group">
          <label for="" class="control-label">Cliente</label>
          <p *ngIf="sale && sale.Cliente && sale.Cliente.Nome">
            {{ sale.Cliente.Nome }}
          </p>
        </div>
      </div>
      <div class="col-xs-12 col-sm-6">
        <div class="form-group">
          <label for="" class="control-label">Descrição</label>
          <p *ngIf="sale && sale.Descricao">
            {{ sale.Descricao }}
          </p>
        </div>
      </div>
    </div>
    <div class="row" *ngIf="sale && sale.Cartao && sale.Cartao.Numero && sale.Cartao.Bandeira && sale.Cartao.DataValidade">
      <div class="col-xs-12">
        <div class="form-group">
          <label class="control-label">Cartão</label>
          <p class="info-cartao" *ngIf="sale && sale.Cartao && sale.Cartao.Numero && sale.Cartao.DataValidade">
            <span class="bandeira-cartao master" [ngClass]="obterClasseBandeira(sale.Cartao.Bandeira)"></span>
            {{ sale.Cartao.Bandeira }} *{{ sale.Cartao.Numero }}
            <small>válido até {{ sale.Cartao.DataValidade }}</small>
            <span class="alterar-cartao" (click)="alterarCartao()">Alterar</span>
          </p>
        </div>
      </div>
    </div>
    <div class="row" *ngIf="sale && sale.Cobrancas && sale.Cobrancas.length > 0">
      <div class="col-xs-12">
        <div class="form-group cobrancas">
          <label class="control-label">Cobranças</label>
          <ol>
            <li *ngFor="let cobranca of sale.Cobrancas" [ngClass]="cobranca.Situacao === 'Recebido' ? 'recebida' : ''">{{ obterData(cobranca.DataCobranca) }} - {{ obterValorReal(cobranca.Valor) }}</li>
          </ol>
        </div>
      </div>
    </div>
    <div class="row">
      <button class="btn btn-blue" *ngIf="sale && sale.Situacao === 'Cancelada' && !hidden" (click)="abrirAlertaReativarVenda()">Reativar Venda</button>
      <button class="btn btn-cancelar" *ngIf="sale && sale.Situacao !== 'Recebido' && sale.Situacao !== 'Cancelada'" (click)="abrirAlertaCancelarVenda()">Cancelar Venda</button>
    </div>
  </div>
</app-modal-detail>

<app-modal-detail [showModal]="alertCancelarVenda" [isAlert]="true">
  <div class="modal-header">
      <h2>Cancelar Venda</h2>
  </div>
  <div class="modal-body">
    <div class="row" *ngIf="!vendaCancelada">
      <p class="text-center empty">Tem certeza de que deseja cancelar a venda?</p>
      <div class="btn-action">
        <button class="btn btn-cancelar" (click)="cancelarVenda()" *ngIf="!cancelandoVenda">Sim</button>
        <button class="btn btn-primary loading" *ngIf="cancelandoVenda"></button>
        <button class="btn btn-default" (click)="fecharAlertaCancelarVenda()">Não</button>
      </div>
    </div>

    <div class="row" *ngIf="vendaCancelada">
      <p class="text-center empty">Venda cancelada com sucesso!</p>
      <div class="btn-action">
        <button class="btn btn-default" (click)="fecharAlertaCancelarVenda()">OK</button>
      </div>
    </div>
  </div>
</app-modal-detail>

<app-modal-detail [showModal]="alertReativarVenda" [isAlert]="true">
    <div class="modal-header">
        <h2>Reativar Venda</h2>
    </div>
    <div class="modal-body">
      <div class="row">
        <p class="text-center empty">Tem certeza de que deseja reativar a venda?</p>
        <div class="btn-action">
          <button class="btn btn-blue" (click)="reativarVenda()">Sim</button>
          <button class="btn btn-default" (click)="fecharAlertaReativarVenda()">Não</button>
        </div>
      </div>
    </div>
  </app-modal-detail>
